ft.app.factory('TemplateHandler', ['$http', '$templateCache', function ($http, $templateCache) {
    return {
        get: function (path) {
            return $http.get(path, {cache: $templateCache});
        }
    };
}]);
